import React from 'react'

const DocumentTypesComp = (props)=> {


    return (
        <div className="panel">
            <div className="panel-header">
                Available Documents
            </div>

            <div className="panel-body">
                <ul>
                    {props.list.map((item,idx)=>(
                    <li key={idx} className="flex">
                        <div className="flex-1">{item.title}</div>
                        <div className="flex-3"><button id="btnWithdraw" type="button" className="btn btn-primary" onClick={p=>props.addNewClickHandler(item)}>Start New</button></div>
                        
                    </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default DocumentTypesComp
